import { observer } from "mobx-react-lite";
import { assert } from "utils";

import { useQuestionnaireSubmissionContext } from "src/questionnaire/QuestionnaireSubmissionContext";
import { SubmissionItem } from "src/questionnaire/SubmissionItem";

interface Props {
  itemId: string;
  disabled: boolean;
}

export const QuestionnaireSubmissionSection = observer(
  function QuestionnaireSubmissionSection(props: Props) {
    const context = useQuestionnaireSubmissionContext();
    const item = context.itemsById[props.itemId];
    assert(item.section);
    const items = context.getItemsByItemId(props.itemId);

    return (
      <div>
        <div className="text-xl pb-4">{item.section.title}</div>
        <div className="space-y-4">
          {items.map((childItem) => (
            <SubmissionItem
              key={childItem.id}
              {...props}
              itemId={childItem.id}
            />
          ))}
        </div>
      </div>
    );
  },
);
